export default "__VITE_ASSET__BN9Aw95d__"